import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="w-full">
      <ol className="flex flex-wrap items-center gap-1.5 font-label text-xs md:text-sm text-foreground-500">
        {items.map((item, i) => {
          const isLast = i === items.length - 1;
          return (
            <li key={`${item.label}-${i}`} className="flex items-center gap-1.5">
              {item.to && !isLast ? (
                <Link to={item.to} className="hover:text-primary-600 transition-colors">
                  {item.label}
                </Link>
              ) : (
                <span className={isLast ? "text-foreground-800" : ""}>{item.label}</span>
              )}
              {!isLast && (
                <i className="ri-arrow-right-s-line text-foreground-300 leading-none"></i>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}